import React from 'react';
import PropTypes from 'prop-types';
import { Step, StepTitle, TitleContainer } from './styles';

const StepItem = ({ icon, title, children }) => (
    <Step>
        <TitleContainer>
            {icon}
            <StepTitle hasIcon={Boolean(icon)}>{title}</StepTitle>
        </TitleContainer>

        {children}
    </Step>
);

StepItem.propTypes = {
    title: PropTypes.string.isRequired,
    icon: PropTypes.node,
    children: PropTypes.node,
};

StepItem.defaultProps = {
    icon: null,
    children: null,
};

export default StepItem;



// WEBPACK FOOTER //
// ./src/components/Step/Step.js